import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

import { DistributorCreateEditController } from './distributor-create-edit.directive.controller'
import { DISTRIBUTOR_SERVICE_NAME, DISTRIBUTOR_ROLE_SERVICE_NAME, DistributorService, DistributorRoleService, } from '../../../services/distributor'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'


//#region Asset Imports

import './distributor-create-edit.scss'
import * as TEMPLATE from './distributor-create-edit.tpl.html'

//#endregion

export class DistributorCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        DISTRIBUTOR_SERVICE_NAME,
        DISTRIBUTOR_ROLE_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        (
            $scope: any,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            distributorService: DistributorService,
            distributorServiceRole: DistributorRoleService,
            userSession: UserSessionService
        ) => new DistributorCreateEditController(
            $scope,
            $q,
            $timeout,
            distributorService,
            distributorServiceRole,
            userSession,
            DistributorService.REFERENCE_TYPE,
            DistributorService.SIMAX_MODULE_NAME
        )]

    controllerAs = "$ctrl"

    template = TEMPLATE
}
